import { render, staticRenderFns } from "./ModifyAccount.vue?vue&type=template&id=7957ed68&scoped=true&"
import script from "./ModifyAccount.vue?vue&type=script&lang=js&"
export * from "./ModifyAccount.vue?vue&type=script&lang=js&"
import style0 from "./ModifyAccount.vue?vue&type=style&index=0&id=7957ed68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7957ed68",
  null
  
)

export default component.exports